export const awardYears = [
  '2027-2028',
  '2026-2027',
  '2025-2026',
  '2024-2025',
  '2023-2024'
];

export const statuses = [
  'PENDING',
  'ONGOING-NSTP1',
  'ONGOING-NSTP2',
  'COMPLETED',
  'REQUESTED FOR SERIAL',
  'WITH SERIAL',
];

export const components = ['CWTS', 'LTS'];
